@if (isHybrid) {
  <!-- TODO translate this -->

  <div>
    <ion-button
      fill="outline"
      expand="block"
      size="small"
      [disabled]="disabled"
      (click)="viewActionSheet()"
    >
      <ion-icon
        slot="start"
        aria-hidden="true"
        src="../assets/material-symbols/photo_camera_24dp.svg"
      ></ion-icon>
      Seleccionar documento o foto
    </ion-button>

    <input
      type="file"
      (change)="onFileSelected($event)"
      #fileInputDocumentMobile
      accept="application/pdf"
    />

    @if (selectedFile) {
      <p class="fs-xs">
        {{ 'general.selected_file' | translate }}:
        <strong>{{ selectedFile.name }}</strong>
      </p>
    }

    @if (cameraService.photo) {
      <img
        [src]="cameraService.photo"
        alt="Foto"
      />
    }

    @if (!hideButton && (selectedFile || cameraService.photo)) {
      <ion-button
        fill="solid"
        size="large"
        expand="block"
        [disabled]="disabled"
        (click)="emitFileToParentComponent()"
        class="ion-margin-top"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/upload_file_24dp.svg"
        ></ion-icon>
        {{ 'general.send_document' | translate }}
      </ion-button>
    }
  </div>
} @else {
  <div
    class="file-drop-area"
    [class.disabled]="disabled"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [ngClass]="{
      dragging: isDragging,
    }"
  >
    <input
      type="file"
      (change)="onFileSelected($event)"
      #fileInputDocument
      [accept]="acceptFormats()"
    />
    <ion-icon
      aria-hidden="true"
      size="large"
      src="../assets/material-symbols/upload_file_24dp.svg"
    ></ion-icon>
    <p>{{ 'general.drag_and_drop_file' | translate }}</p>
    @if (!hideButton) {
      <p>
        <strong>{{ 'general.then_send_document' | translate }}</strong>
      </p>
    }
    <p class="fs-xs">
      {{ 'general.selected_file' | translate }}:
      @if (selectedFile) {
        <strong>{{ selectedFile.name }}</strong>
      } @else {
        {{ 'general.none' | translate }}
      }
    </p>
  </div>

  @if (!hideButton) {
    <div class="desktop-upload-button">
      <ion-button
        fill="outline"
        color="primary"
        size="large"
        expand=""
        (click)="emitFileToParentComponent()"
        [disabled]="disabled || selectedFile === null"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/upload_file_24dp.svg"
        ></ion-icon>
        {{ 'general.send_document' | translate }}
      </ion-button>
    </div>
  }
}
